/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import {
  getForteDecisionFlagWithTrueDefault,
  useForteDecisionFlagWithTrueDefault,
} from '@/features/forte/api/getForteDecision';
import { type QueryClient } from '@tanstack/react-query';

type OMSFlags = {
  useOMSInventoryQohService: boolean;
};

/**
 * Retrieves OMS (Order Management System) feature flags fetched from Forte in the query client.
 *
 * @param queryClient - The React Query client instance used to fetch feature flags
 * @returns An object containing OMS feature flags
 * @throws Error when queryClient is undefined
 */
export const getOMSFlags = (queryClient: QueryClient | undefined): OMSFlags => {
  if (!queryClient) {
    throw new Error('Forte config is undefined');
  }
  const useOMSInventoryQohService = getForteDecisionFlagWithTrueDefault(
    queryClient,
    'useOMSInventoryQohService',
  );

  return {
    useOMSInventoryQohService,
  };
};

export const useOMSFlags = () => {
  const useOMSInventoryQohService = useForteDecisionFlagWithTrueDefault(
    'useOMSInventoryQohService',
  );

  return {
    useOMSInventoryQohService,
  };
};
